import { useEffect } from "react";
import { pushToDataLayer, createNavigationEventForGTM } from "~/lib/gtm";

export function useNavigationMonitor() {
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      // Push to GTM data layer
      const gtmEvent = createNavigationEventForGTM(
        "browser_history_change",
        window.location.pathname,
        window.location.search,
        window.location.hash,
        event.state
      );
      pushToDataLayer(gtmEvent);
    };

    // Add event listener for popstate (browser back/forward buttons)
    window.addEventListener("popstate", handlePopState);

    // Cleanup function
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
}
